import { CheckboxGroups } from "./types";

export const EMPTY_FILTERS = {
  search: "",
  types: [],
  topics: [],
  grades: [],
  activities: [],
  categories: [],
  activityTypes: [],
};

export const CHECKBOX_GROUP_NAMES: (keyof CheckboxGroups)[] = [
  "types",
  "topics",
  "grades",
  "activities",
];
